import { useEffect, useState } from 'react';

const useTrendingItems = (trending_items: any[]) => {
  const [trending_items_ids, set_trending_items_ids] = useState<any[]>(
    trending_items.map((i) => i.ticker_id).filter((i) => i) // remove nulls
  );

  const [trending_items_no_ids, set_trending_items_no_ids] = useState<any[]>(
    trending_items.filter((i) => !i.ticker_id) // Only nulls
  );

  // update items if they are loaded after component is mounted
  useEffect(() => {
    set_trending_items_ids(
      trending_items.map((i) => i.ticker_id).filter((i) => i)
    );

    set_trending_items_no_ids(trending_items.filter((i) => !i.ticker_id));
  }, [trending_items.length]);

  return {
    trending_items_ids: trending_items_ids ?? [],
    trending_items_no_ids,
  };
};

export default useTrendingItems;
